<template>
  <div class="bgComment">
    <div class="comment-container">
      <!-- 投票 -->
      <h2 class="header">{{ title }}</h2>
      <div class="layout" v-for="(item, index) in choiceOptions" :key="index">
        <div class="vote-option">
          <div class="vote-option-content">
            <span class="option-text"
              >{{ letterOptions[index] }}、{{ item.text }}</span
            >
            <div>
              <span class="option-data">{{ item.numberofuser }}人</span>
              <span class="option-data">{{ item.percentageamount }}%</span>
            </div>
          </div>
          <div
            class="process"
            :style="{ width: item.percentageamount + '%' }"
          ></div>
        </div>
        <div class="voted" ref="photoSetting" v-if="item.userresponses.length">
          <img
            v-for="(user, index) in item.userresponses"
            :key="index"
            :src="user.profileimageurl"
            class="unit"
          />
        </div>
        <div v-else class="voted empty-message">
          暂无投票信息
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import course from "@/api/course/index";
import utils from "@/utils/index";
import "@vant/touch-emulator";
import { picker } from "vant";
import {
  Row,
  Col,
  CountDown,
  Image,
  Dialog,
  Button,
  Toast,
  Picker,
} from "vant";
Vue.use(Row)
  .use(Col)
  .use(CountDown)
  .use(Image)
  .use(Dialog)
  .use(Button)
  .use(Picker);
// @ is an alias to /src
export default {
  data() {
    return {
      title: "",
      letterOptions: "ABCDEFGHIJKLMNOPQRSTUVWXYZ", //选项的序号
      files: [],
      allowmultiple: false, // 是否多选题
      choiceOptions: [],
    };
  },
  computed: {
    userinfo() {
      return this.$store.state.auth.userinfo;
    },
  },
  methods: {
    // 获取投票结果
    async getChoiceResult() {
      let { courseId, choiceid } = this.$store.state.course;
      const _this = this;
      let result = await course.getChoiceResult({
        params: { choiceid: choiceid },
        loadingText: "正在加载投票结果...",
        errorFn: this.handleError,
      });
      if (result && result.options) {
        this.choiceOptions = result.options;
        let cResult = await course.getChoiceByCourseId({
          params: { courseids: [courseId] },
          loadingText: "",
          errorFn: this.handleError,
        });
        console.log("choiceOption", this.choiceOptions);
        if (!cResult) return false;
        console.log("choices", cResult.choices);
        cResult.choices.forEach((v) => {
          if (choiceid === v.id) {
            this.title = v.name;
            this.allowmultiple = v.allowmultiple;
            this.files = v.introfiles || [];
          }
        });
      }
    },
    async onmessage() {
      const _this = this;
      this.$root.$on("handleDeleteTopic", (data) => {
        _this.deleteTopic(data);
      }),
        this.$root.$on("updateData", () => {
          console.log("update vote");
          _this.getChoiceResult();
        });
    },
  },
  beforeDestroy() {
    this.$root.$off("handleDeleteTopic");
  },
  created() {
    // this.onmessage();
  },
  mounted() {
    this.onmessage();
    this.getChoiceResult();
  },
};
</script>
<style lang="less" scoped>
.text-two {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.bgComment {
  height: 100%;
  z-index: 9;
  position: relative;
  overflow: hidden;
  padding: 50px 160px;
  .comment-container {
    background: #fff;
    border-radius: 48px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
    padding: 60px;
    height: 100%;
  }
  .header {
    font-size: 36px;
    color: #333;
    margin-bottom: 30px;
  }
  .layout {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 120px;
    margin-bottom: 30px;
    align-items: center;
    .vote-option {
      width: 63.7681%;
      background-color: #fff;
      border: 1px #ddd solid;
      border-radius: 16px;
      padding: 0 30px;
      height: 120px;
      .vote-option-content {
        height: calc(100% - 4px);
        display: flex;
        justify-content: space-between;
        font-size: 30px;
        padding: 30px 0;
        line-height: 52px;
        .option-text {
          color: #333;
          display: inline-block;
        }
        .option-data {
          color: #37ab7e;
          padding-left: 30px;
        }
      }
      .process {
        height: 4px;
        max-width: 100%;
        background-color: #37ab7e;
        border-radius: 2px;
        transition: 0.5s;
      }
    }
    .voted {
      width: 34.79%;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      // align-content: center;
      align-items: center;
      margin-right: -5px;
      overflow-y: auto;
      .unit {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin: 10px 5px;
      }
      &.empty-message {
        text-align: center;
        font-size: 24px;
        color: #a6a6a6;
        justify-content: center;
      }
    }
  }
}
</style>